module.exports = __webpack_public_path__ + "img/detail_bg3.946b302e.png";